import CONSTANTES from "../constantes";


export const reducerCatalogo = (state = { categorias: [],catalogo:[] }, action) => {
    switch (action.type) {
        case CONSTANTES.PUT_CATEGORIAS:
            return { ...state, categorias: action.categorias }
        case CONSTANTES.ADD_CATEGORIA:
                state.categorias.unshift(action.categoria)
                return { ...state, categorias:[...state.categorias]}
        case CONSTANTES.PUT_CATALOGO:
            return { ...state, catalogo:[...action.catalogo]}
        default:
            return state
    }
}